<template>
  <div class="app-sim-order-wrapper">
      <slot name="txtBefore"></slot>
    <div slot="modal-title">
    </div>
    <slot name="txtModalBody">
      <div class="option-boxes">
        <div class="option-image" :class="{'highlight-option': selectedSimType === SimTypes.simCardCode}">
          <slot name="optionImage"></slot>
        </div>
        <div v-if="showEsim" class="option-esim" :class="{'highlight-option': selectedSimType === SimTypes.eSimCode}">
<!--          <slot name="optionEsim"></slot>-->
          <span>eSIM</span>
        </div>
        <div class="option-price" >
          <span>{{substituteSimCardOptions_.price}} €</span>
          <slot name="txtAfterPrice"></slot>
        </div>
      </div>
    </slot>

    <div class="mt-5 mb-2">
      <slot v-if="!showEsim" name="txtUnshowEsim">asdasdasd</slot>

      <p><slot name="beforeSimTypeSelectionLabel"><strong>SIM-Typ wählen</strong>*</slot></p>
      <b-form>
          <b-form-group label="SIM-Typ wählen" label-class="visually-hidden">
              <b-form-radio-group v-model="simtype_" required aria-required="true">
                      <b-form-radio id="selectSimCard" name="simType" :value="SimTypes.simCardCode" class="mr-5">
                          <slot name="lblClassicSim">{{ SimTypes.simCardLabel }}</slot>
                      </b-form-radio>
                      <b-form-radio v-if="showEsim" id="selectESim" name="simType" :value="SimTypes.eSimCode">
                          <slot name="lblESim">{{ SimTypes.eSimLabel }}</slot>
                      </b-form-radio>
                      <span v-if="showEsim" class="info-tooltip">
                          <span class="simOrderToolTip">
                            <ToolTip placement="right" triggers="hover">Sobald Deine eSIM verfügbar ist, erhältst Du weitere Informationen per Email, um diese zu aktivieren. Bitte beachte, dass jeder weitere SIM-Tausch kostenpflichtig ist.</ToolTip>
                          </span>
                      </span>
                </b-form-radio-group>
          </b-form-group>
      </b-form>
    </div>
    <slot name="txtSimCardBetween" v-if="selectedSimType === SimTypes.simCardCode"></slot>
    <slot name="txtESimBetween" v-if="selectedSimType === SimTypes.eSimCode"></slot>
    <div class="row p-4" v-if="selectedSimType === SimTypes.eSimCode">
      <slot name="txtDeviceCheck">
        <p><strong>Ist dein Gerät eSIM-fähig? <span class="link" @click="toggleText">Prüfe es hier!</span></strong></p>
      </slot>
    </div>
    <ESimDeviceCheck v-if="showDeviceCheckText"></ESimDeviceCheck>
    <CustomerAddress :process-name="'simOrder'" v-if="selectedSimType === SimTypes.simCardCode">
      <template v-for="slot in possibleChildSlotsFor('Address')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </CustomerAddress>
    <div class="row p-4" v-if="selectedSimType === SimTypes.eSimCode">
      <span>E-Mail-Adresse: {{ currentCustomer.email }} </span>
    </div>
    <slot name="txtAfter"></slot>
    <div slot="modal-footer">
      <dyn-slot :slot-data="slotData">
      <slot name="txtCostInfo"></slot>
      </dyn-slot>
      <Stepper
        @next="next"
        :show-prev="false"
        :disabled-next="false"
      >
        <template #btnPrev><slot name="btnPrev"></slot></template>
        <template #btnNext><slot name="btnNext"></slot></template>
      </Stepper>
    </div>
  </div>
</template>

<script>

import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'
import gql from 'graphql-tag'
import Stepper from '@/components/generic/Stepper.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import CustomerAddress from './Address.vue'
import { SimTypes } from '@/helper/SimTypes'
import syncProperty from '@/mixins/syncProperty'
import ToolTip from '@/components/generic/Tooltip'
import ESimDeviceCheck from '@/components/process/LIDL/SimCard/ESimDeviceCheck/ESimDeviceCheck.vue'

export default {
  name: 'SimOrderWrapper',
  components: { CustomerAddress, Stepper, ToolTip, ESimDeviceCheck },
  mixins: [
    transaction('simOrder'),
    slotProxy(),
    syncProperty('simtype', 'simtype_')
  ],
  methods: {
    next () {
      this.$emit('next', this.substituteSimCardOptions_.productNumber)
    },
    toggleText () {
      this.showDeviceCheckText = !this.showDeviceCheckText
    }
  },
  data () {
    return {
      substituteSimCardOptions: [{ price: '', type: SimTypes.simCardCode }],
      SimTypes,
      showDeviceCheckText: false,
      currentCustomer: {
        email: ''
      }
    }
  },
  slotData: {
    type: Object
  },
  computed: {
    substituteSimCardOptions_ () {
      let selectedOptions = null

      if (this.substituteSimCardOptions.length > 0) {
        for (const options of this.substituteSimCardOptions) {
          if (options.type === this.simtype_) {
            selectedOptions = options
            break
          }
        }
      }

      return selectedOptions
    },
    slotData () {
      return this.substituteSimCardOptions_
    },
    selectedSimType () {
      return this.simtype_
    }
  },
  apollo: {
    substituteSimCardOptions: function () {
      return wrapQuery(
        gql`query simOrder {
                    substituteSimCardOptions{
                        description
                        name
                        price
                        productNumber
                        type
                        possibleActivationSettings
                        productPrice
                        shippingCosts
                        total
                    },
                    currentCustomer {
                        email
                    }
                }`, this, ['substituteSimCardOptions', 'currentCustomer'], {}, null,
        {
          fetchPolicy: 'cache-first'
        }
      )
    }
  },
  props: {
    showEsim: {
      type: Boolean,
      default: false
    }
  }
}
</script>
